<template>
  <div>
    <list
      :model="model"
      :index-select="indexSelect"
      :allow-search="allowSearch"
      ref="list"
      @selected="selected"
      @search-end="$emit('search-end')"
      @grid-ready="$emit('grid-ready')"
      :name-select="nameSelect"
      @saved="search(false)"
      :print="print"
      :prop-edit="edit"
    >
    </list>
    <vs-popup class="popup80 noOverflow" :title="title" :active.sync="showDoc">
      <object :data="srcPdf" width="100%" style="height: 600px" />
    </vs-popup>
  </div>
</template>

<script>
import List from '@/components/SigList'
import model from '@/store/httpCommand/model'

export default {
  components: {
    List
  },
  props: ['indexSelect', 'allowSearch', 'nameSelect'], // allowSearch - Permitir busca automatica no grid
  data () {
    return {
      model,
      showDoc: false,
      srcPdf: '',
      title: ''
    }
  },
  methods: {
    refresh () {
      this.$refs.list.refresh()
    },
    filter (value) {
      this.$refs.list.filter(value)
    },
    search (value) {
      this.$refs.list.search(value)
    },
    selected (payload) {
      this.$emit('selected', payload)
    },
    edit (data) {
      this.$emit('edit')
      this.$store.commit(this.model.$store.commit.command, {
        url: data.data.url,
        params: data.data.params
      })
    },
    async print (data) {
      try {
        this.$vs.loading()
        const resp = await this.$http.post(data.data.url, data.data.params)
        this.title = data.data.name
        this.srcPdf = `data:application/pdf;base64,${resp.data}`
        this.showDoc = true
        this.$nextTick(() => {
          this.$vs.loading.close()
        })
      } catch (error) {
        this.$vs.loading.close()
      }
    }
  }
}
</script>
